<script>
import SimulatorOfficialResultComponent from '../../features/details/SimulatorOfficialResultComponent';
import ModalSimulatorResultAnswers from '../modals/ModalSimulatorResultAnswers';

export default {
  name: 'SimulatorOfficialResultView',
  components: {
    'modal-simulator-result-answers-view': ModalSimulatorResultAnswers,
  },
  extends: SimulatorOfficialResultComponent,
  methods: {
    // Traduce el porcentaje de aciertos al badge del design system.
    getStatusBadge(percentage) {
      if (percentage >= 0 && percentage < 70) {
        return 'is_danger';
      }
      if (percentage >= 70 && percentage < 90) {
        return 'is_warning';
      }
      if (percentage > 90 && percentage <= 100) {
        return 'is_success';
      }
      return 'is_purple';
    },
  },
};
</script>
<template>
  <div class="sim_apply_result">
    <template v-if="simulatorResult">
      <!-- Resumen del resultado -->
      <div class="sim_apply_result_hero">
        <div class="sim_apply_result_intro">
          <div class="sim_apply_result_kicker">
            <i class="fas fa-award" /> Resultado del simulador
          </div>
          <h3 class="sim_apply_result_student">
            <i class="fas fa-user-graduate" /> {{ simulatorResult.student }}
          </h3>
          <p class="sim_apply_result_greeting">
            <i class="fas fa-star" /> {{ simulatorResult.greeting }}
          </p>
        </div>

        <div class="sim_apply_result_score">
          <div class="sim_apply_score_ring">
            <span class="sim_apply_score_value">{{ simulatorResult.finalScore }}</span>
            <span class="sim_apply_score_label">Puntos</span>
          </div>
        </div>
      </div>

      <!-- Métricas -->
      <div class="sim_apply_result_metrics">
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Puntaje mínimo</span>
          <span class="sim_apply_metric_value">{{ simulatorResult.lowScore }}</span>
        </div>
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Puntaje máximo</span>
          <span class="sim_apply_metric_value">{{ simulatorResult.topScore }}</span>
        </div>
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Posicionamiento</span>
          <span class="sim_apply_metric_value">{{ simulatorResult.rank }}</span>
        </div>
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Simulador</span>
          <span class="sim_apply_metric_value">{{ simulatorResult.simulatorName }}</span>
        </div>
      </div>

      <!-- Resultados por sección -->
      <div class="sim_apply_result_table">
        <div class="sim_apply_result_row is_head">
          <div class="sim_apply_result_section_name">
            Sección
          </div>
          <div class="sim_apply_result_badge_label">
            Aciertos / Preguntas
          </div>
          <div class="sim_apply_result_badge_label">
            Detalle
          </div>
        </div>

        <div
          v-for="(section, index) in simulatorResult.sectionResults"
          :key="index"
          class="sim_apply_result_row"
        >
          <div class="sim_apply_result_section_name">
            {{ section.name }}
          </div>

          <span
            class="sim_apply_result_badge"
            :class="getStatusBadge(section.percentage)"
          >
            {{ section.totalSuccess }}/{{ section.totalQuestions }}
          </span>

          <button
            type="button"
            class="account_btn_primary"
            @click="onGetAnswersResult(section)"
          >
            <i class="uil uil-eye" /> Ver resultados
          </button>
        </div>
      </div>

      <!-- Acciones finales -->
      <div class="sim_apply_result_actions">
        <button
          type="button"
          class="account_btn_primary"
          @click="onFinish"
        >
          <i class="uil uil-arrow-left" /> Regresar a Simuladores
        </button>
        <button
          type="button"
          class="sim_apply_nav_btn"
          @click="onRepeat"
        >
          <i class="uil uil-redo" /> Repetir simulador
        </button>
      </div>
    </template>

    <div v-loading.fullscreen.lock="isLoading" />
    <modal-simulator-result-answers-view
      v-if="modalShowResults.isVisible"
      :conf="modalShowResults"
      :form-data="resultAnswers"
    />
  </div>
</template>
